import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import jobsReducer from './reducers';

const importJobsSubaccount = () => import(/* webpackChunkName: "jobs-subaccount" */ './containers/JobsSubaccountContainer');

const JobsSubaccountRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <BundleRoute
      load={importJobsSubaccount}
      path={`${match.url}/:username/dashboard/:tabName?/:cloudType?`}
    />
  </LoginRequiredContainer>
);

JobsSubaccountRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.jobs', attachReducer(jobsReducer),
)(JobsSubaccountRoutes);
export { JobsSubaccountRoutes };
